import { useDisclosure } from '@dwarvesf/react-hooks';
import { Box } from '@mui/material';
import { SLALoadingState } from 'features/socialListeningAnalytics/components/slaLoadingState';
import {
  BrandCompetitorMentionSource,
  MetricsTimeRange,
  useGetBrandDataForSocialListeningAnalyticsCompetitorsQuery,
} from 'graphql/generated';
import { useState } from 'react';

type Props = {
  brandId: string;
};

export const SocialMediaListeningAnalyticsSentimentView = ({
  brandId,
}: Props) => {
  const brandSentimentTrendDisclosure = useDisclosure();
  const [selectedBrandId, setSelectedBrandId] = useState('');

  const [timeRange, setTimeRange] = useState(MetricsTimeRange.OneWeek);
  const [filteredTopicIds, setFilteredTopicIds] = useState<string[]>([]);
  const [sources, setSources] = useState<BrandCompetitorMentionSource[]>(
    Object.values(BrandCompetitorMentionSource),
  );

  const {
    data: brandData,
    refetch: refetchCompetitorsData,
    loading: brandLoading,
  } = useGetBrandDataForSocialListeningAnalyticsCompetitorsQuery({
    variables: {
      id: brandId,
      competitorsDataInput: {
        timeRange,
        topicIds: filteredTopicIds,
        sources,
      },
    },
  });
  const currentBrand = brandData?.brand;

  if (brandLoading) {
    return (
      <Box
        height="calc(100vh - 200px)"
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <SLALoadingState />
      </Box>
    );
  }

  return (
    <Box display="flex" my={4} flexDirection="column">
      <Box display="flex" gap={2} justifyContent="space-between" mb={6} />
    </Box>
  );
};
